import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../../../../../ricercaSegnalazioni/ricercaSegnalazioni.module.css";
import Input from "../../../../../../../components/textbox/Input";
import MediciService from "../../../../../../../services/MediciService";
import Utils from "../../../../../../../utils/Utils";
import log from "eslint-plugin-react/lib/util/log";

class DatiCompilatore extends Component {


    state = {
        datiCompilatore: {
            cognome: "",
            nome: "",
            telefono: "",
            email: "",
            corretto: []
        }
    };

    constructor(props) {
        super(props);

        
        this.letturaMedico = this.letturaMedico.bind(this);
        this.riceviValore = this.riceviValore.bind(this);
        this.aggiornaPadre = this.aggiornaPadre.bind(this);
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this);
    }

    componentDidMount() {
        if (
            this.props.segnalazioneCopia &&
            this.props.segnalazioneCopia.schedaSpeciale &&
            this.props.segnalazioneCopia.schedaSpeciale.datiCompilatore
        ) {
            this.setState(
                {
                    datiCompilatore: {
                        ...this.state.datiCompilatore,
                        ...this.props.segnalazioneCopia.schedaSpeciale.datiCompilatore
                    }
                },
                () => this.aggiornaPadre()
            );
        }else if (this.props.segnalazioneCopia?.medicoId) {
            this.letturaMedico(this.props.segnalazioneCopia.medicoId);
        } else{
            this.aggiornaPadre();
        }
    }

    riceviValore(field, value) {
        const newValue = value && value.target ? value.target.value : value;

        this.setState(prevState => {
            const nuovo = {
                ...prevState.datiCompilatore,
                [field]: newValue
            };

            return {
                datiCompilatore: {
                    ...nuovo,
                    corretto: this.controlloCorrettezza(nuovo)
                }
            };
        }, this.aggiornaPadre);
    }

    controlloCorrettezza() {
        let dati = this.state.datiCompilatore;
        dati.corretto = [];
    }

    aggiornaPadre() {
        this.controlloCorrettezza();

        if (this.props.controlloCorrettezza) {
            this.props.controlloCorrettezza();
        }

        let oggettoBE = this.createOggettoBE();

        if (this.props.setDatiCompilatore) {
            this.props.setDatiCompilatore(
                this.state.datiCompilatore,
                oggettoBE
            );
        }
    }

    createOggettoBE() {
        let copiaDati = JSON.parse(JSON.stringify(this.state.datiCompilatore));
        let pulito = Utils.removeEmptyValueFromObject(copiaDati);
        return Utils.removeFieldFromObject(pulito, "corretto");
    }

    letturaMedico(idMedico) {
        MediciService.getMedicoById(idMedico)
            .then((data) => {
                let datiMedico = JSON.parse(JSON.stringify(data.data));

                const nuovoCompilatore = {
                    cognome: datiMedico.cognome || "",
                    nome: datiMedico.nome || "",
                    telefono: datiMedico.recapitoTelefonico || "",
                    email: datiMedico.email || "",
                    corretto: []
                };

                this.setState({
                    datiCompilatore: {
                        ...nuovoCompilatore,
                        corretto: []
                    }
                },
                () => {
                    this.aggiornaPadre();
                }
            );
            })
            .catch((reason) => {
                console.log("[ERROR] get lettura medico: " + reason);
                this.aggiornaPadre();
            });
    }

    render() {
        const { t } = this.props;
        const data = this.state.datiCompilatore || {};
        const path = "SchedaSpecialeArbovirosi.datiCompilatore";

        return (
            <div>
                <div className={"container"}>
                    <div style={{marginTop: "10px"}}/>
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="row">
                                <div className="col-lg-6" style={{ marginTop: "10px" }}>
                                    <p className={styles.labelHeader}>
                                        <b>Cognome</b>
                                    </p>
                                </div>
                                <div className="col-lg-6">
                                    <Input
                                        id={"idcognome"}
                                        onChange={this.riceviValore}
                                        field={"cognome"}
                                        value={data.cognome || ""}
                                        placeholder={"Cognome"}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-1" />

                        <div className="col-lg-5">
                            <div className="row">
                                <div className="col-lg-6" style={{ marginTop: "10px" }}>
                                    <p className={styles.labelHeader}>
                                        <b>Nome</b>
                                    </p>
                                </div>
                                <div className="col-lg-6">
                                    <Input
                                        id={"idnome"}
                                        onChange={this.riceviValore}
                                        field={"nome"}
                                        value={data.nome || ""}
                                        placeholder={"Nome"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{ marginTop: "10px", height: "60px" }}>
                        <div className="col-lg-5">
                            <div className="row">
                                <div className="col-lg-6" style={{ marginTop: "10px" }}>
                                    <p className={styles.labelHeader}>
                                        <b>Telefono</b>
                                    </p>
                                </div>
                                <div className="col-lg-6">
                                    <Input
                                        id={"idtelefono"}
                                        onChange={this.riceviValore}
                                        field={"telefono"}
                                        value={data.telefono || ""}
                                        placeholder={"Telefono"}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-1" />

                        <div className="col-lg-5">
                            <div className="row">
                                <div className="col-lg-6" style={{ marginTop: "10px" }}>
                                    <p className={styles.labelHeader}>
                                        <b>Email</b>
                                    </p>
                                </div>
                                <div className="col-lg-6">
                                    <Input
                                        id={"idemail"}
                                        onChange={this.riceviValore}
                                        field={"email"}
                                        value={data.email || ""}
                                        placeholder={"Email"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}






export default withTranslation('common')(DatiCompilatore)

